import HallCreateForm from "./hall-create-form";

export default HallCreateForm;